import { LoaderFunctionArgs, useLoaderData } from "react-router-dom";
import { loadRecipeRaw } from "../data";
import React from "react";

export async function loader({ request }: LoaderFunctionArgs) {
    const pkgPromise = import("./EditRecipeView");
    const url = new URL(request.url);
    const id = url.searchParams.get("id") || "";
    if (id) {
        const recipeId = parseInt(id, 10);
        if (recipeId) {
            const [recipe, pkg] = await Promise.all([loadRecipeRaw(recipeId), pkgPromise]);
            return { recipe, view: pkg.default };
        }
    }

    const pkg = await pkgPromise;
    return { view: pkg.default };
}

export default function EditRecipeLoader() {
    const { view } = useLoaderData() as { view: () => JSX.Element };
    return React.createElement(view);
}
